import React from 'react'
import { t } from 'ttag'

import { MessageAlert } from 'components/shared/Alerts/MessageAlert/MessageAlert'
import { Modal } from 'components/shared/Modal/Modal'

import styles from './DoubleConfirmation.module.scss'

export const DoubleConfirmationModal = ({
  cancelLabel = t`Go back`,
  confirmLabel = t`Close`,
  text = t`Are you sure you want to close?`,
  title = t`Close`,
  message = t`All data you provided will be lost.`,
  onCancel,
  onClose,
  onConfirm,
  isOpen,
}) => (
  <Modal
    className={styles.modal}
    {...{
      cancelLabel,
      confirmLabel,
      title,
      onCancel,
      onClose,
      onConfirm,
      isOpen,
    }}
  >
    <Modal.Header />
    <Modal.Content className={styles.content}>
      <MessageAlert message={message} variant="warning" isInitialised />
      <p className={styles.text}>{text}</p>
    </Modal.Content>
    <Modal.Footer />
  </Modal>
)
